import type { ReactNode } from "react";
import type { NodeCategory } from "../model";
import "./NodeVisuals.scss";

export function Icon({
  children,
  className = "icon",
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <svg
      aria-hidden="true"
      className={`${className} icon`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

export function NodeGlyph({
  category,
  className,
}: {
  category: NodeCategory;
  className?: string;
}) {
  if (category === "source")
    return (
      <Icon className={className}>
        <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.5z" />
        <circle cx="12" cy="13" r="3" />
      </Icon>
    );
  if (category === "output")
    return (
      <Icon className={className}>
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
      </Icon>
    );
  if (category === "logic")
    return (
      <Icon className={className}>
        <path d="m12.83 2.18 8 4a2 2 0 0 1 0 3.58l-8 4a2 2 0 0 1-1.66 0l-8-4a2 2 0 0 1 0-3.58l8-4a2 2 0 0 1 1.66 0Z" />
        <path d="m22 12-9.17 4.58a2 2 0 0 1-1.66 0L2 12" />
        <path d="m22 17-9.17 4.58a2 2 0 0 1-1.66 0L2 17" />
      </Icon>
    );
  if (category === "inference")
    return (
      <Icon className={className}>
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
        <path d="M8 11h6M11 8v6" />
      </Icon>
    );
  if (category === "analytics")
    return (
      <Icon className={className}>
        <path d="M3 3v18h18" />
        <path d="m19 9-5 5-4-4-3 3" />
      </Icon>
    );
  return (
    <Icon className={className}>
      <path d="M4 13h4l2-7 3 12 2-5h5" />
    </Icon>
  );
}

export function WarningGlyph() {
  return (
    <Icon className="node-warning-icon">
      <path d="m12 3 10 18H2z" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </Icon>
  );
}
